import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class SettingsService {
  constructor(
    private httpClient: HttpClient
  ) { }
  mobile = false;
  getSettings() {
    return this.httpClient.get<any>(`${environment.serverPath}/settings`);
  }

  updateSettings(model: any) {
    return this.httpClient.post(`${environment.serverPath}/settings`, model);
  }

  getProfile() {
    return this.httpClient.get<any>(`${environment.serverPath}/settings/profile`);
  }

  updateProfile(model: any) {
    return this.httpClient.post(`${environment.serverPath}/settings/profile`, model);
  }
}
